export const ThemeBG1 = "#ebf6ff";

//https://shivapdf.com/scripts/backend.php
//http://localhost/shivapdf/backend.php #developement
export const REQUEST_URL = "https://shivapdf.com/scripts/backend.php";
//https://shivapdf.com/scripts/query_form.php
//http://localhost/shivapdf/query_form.php #developement
export const QUERY_FORM_URL = "https://shivapdf.com/scripts/query_form.php";
//server authentication url
//https://shivapdf.com/scripts/authentication.php
//http://localhost/shivapdf/authentication.php #developement
export const AUTHENTICATION_URL = "https://shivapdf.com/scripts/authentication.php";

//base url
export const BASE_URL = "https://shivapdf.com";

//temp file storage database name
export const TMP_DB_NAME = "my_files_storage_db";

//runpod status check interval
export const STATUS_CHECK_INTERVAL = 3000; // 3 seconds
//max file size that can be uploaded
//runpod datauri method only supports 10 mb max
//for higher limit we need to upload original file as multipart data
//also change this value on server config.php file
export const MAX_UPLOAD_FILE_SIZE = 1024 * 1024 * 30;

//facebook page url
export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61596218249071"
//youtube page url
export const YOUTUBE_URL = "https://www.youtube.com/@millionxgames6264"
//x page url
export const X_URL = "https://x.com/tube4dl"
